import styled from 'styled-components';

export const DatePickerContainer = styled.div`
    margin-bottom: 13px;
`;
